import React from "react";
import styled from "styled-components";
import Header from "../../components/Header";
import PageContainer from "../../components/PageContainer";

const Frame = styled.div`
  border: 1px solid silver;
  padding: 0.5em;
  margin-top: 1em;
  display: inline-block;
  margin-right: 1em;
  vertical-align: bottom;
  border-radius: 5px;
`;

export default function StartErrorPage({ title }) {
  return (
    <PageContainer>
      <Header>{title}</Header>
      There was an error starting the test, sorry for that
      <br />
      Please contact the account manager:
      <br />
    </PageContainer>
  );
}
